import "./TradingIdeasMobileComponent.scss";
import {IComponentOptions, IOnDestroy, IOnInit} from "angular";
import {TradingIdeasViewStore} from "../store/TradingIdeasViewStore";
import {TradingIdeasService} from "../service/TradingIdeasService";
import {ReplaySubject} from "rxjs";
import {IsoDate} from "../../pseudo-types/DateTypes";

export const TradingIdeasMobile = "tfTradingIdeasMobile";

export function tradingIdeasMobile(parentDir: string): IComponentOptions {
    return {
        templateUrl: `${parentDir}/mobile/TradingIdeasMobileComponent.html`,
        controllerAs: "ctrl",
        controller: TradingIdeasMobileComponentController
    };
}

export class TradingIdeasMobileComponentController implements IOnInit, IOnDestroy {

    public readonly store: TradingIdeasViewStore;

    public readonly currentIdeaName$ = new ReplaySubject<string>(1);
    public readonly currentIdeaExpiry$ = new ReplaySubject<IsoDate>(1);
    public readonly hasIdeas$ = new ReplaySubject<boolean>(1);

    private readonly destroyed$ = new ReplaySubject<boolean>(1);

    /** @ngInject */
    public constructor(tradingIdeasService: TradingIdeasService) {
        this.store = new TradingIdeasViewStore(tradingIdeasService);
    }

    public $onInit(): void {
        this.store
            .currentModel
            .takeUntil(this.destroyed$)
            .subscribe((model) => {
                const name = `${model.idea.underlying} ${model.idea.name}`;
                this.currentIdeaName$.next(name);
                this.currentIdeaExpiry$.next(model.idea.expiry);
            });

        this.store
            .hasIdeas
            .takeUntil(this.destroyed$)
            .subscribe((hasIdeas) => this.hasIdeas$.next(hasIdeas));
    }

    public $onDestroy(): void {
        this.store.destroy();
        this.destroyed$.next(true);
        this.destroyed$.complete();
    }
}
